import * as PropTypes from 'prop-types';
import * as React from 'react';

class CreditCardIcon extends React.Component {
  get cardIconClass() {
    return (
      `cc-${this.props.cardType.replace(/\s+/g, '-').toLowerCase()}`
    );
  }

  render() {
    if (!this.props.cardType) { return false; }

    return (
      <div className={this.cardIconClass} />
    );
  }
}

CreditCardIcon.propTypes = {
  cardType: PropTypes.string,
};

export default CreditCardIcon;



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/credit_card_icon.jsx